import { isEncompass } from '$Utilities/integrationPlatform';
import { Box } from '@mui/material';
import { React } from 'Imports';

const styles = require('./DateRangeSummary.scss') as {
    dayCounterContainerEncompass: string;
    dayCounterTextEncompass: string;
    dayCounterSubtextEncompass: string;
    dayCounterContainerGeotab: string;
    dayCounterTextGeotab: string;
    dayCounterSubtextGeotab: string;
};

interface IDateRangeSummaryProps {
    selectedDaysCount: number;
    maxDays: number;
}

export const DateRangeSummary: React.FC<IDateRangeSummaryProps> = ({ selectedDaysCount: daysDiff, maxDays }) => {
    return (
        <Box
            className={isEncompass ? styles.dayCounterContainerEncompass : styles.dayCounterContainerGeotab}
            data-testid={'date-range-picker-footer-container'}
        >
            <Box className={isEncompass ? styles.dayCounterTextEncompass : styles.dayCounterTextGeotab}>
                {`${daysDiff} day${daysDiff === 1 ? '' : 's'} selected`}
            </Box>
            <Box className={isEncompass ? styles.dayCounterSubtextEncompass : styles.dayCounterSubtextGeotab}>
                A max of {maxDays} days can be selected as the date range from the start to end date.
            </Box>
        </Box>
    );
};

export default DateRangeSummary;
